import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import "../css/Inicio.css";

function Inicio() {
  const cookies = new Cookies();
  const [nombre, setNombre] = useState("");
  const [perfil, setPerfil] = useState("");
  const [hora, setHora] = useState(new Date());

  useEffect(() => {
    setNombre(cookies.get("nombresApellidos") || "");
    setPerfil(cookies.get("perfil") || "");
    const timer = setInterval(() => setHora(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Saludo según hora del día
  const getSaludo = () => {
    const h = hora.getHours();
    if (h >= 5 && h < 12) return "¡Buenos días";
    if (h >= 12 && h < 18) return "¡Buenas tardes";
    return "¡Buenas noches";
  };

  const formatName = (name) => {
    if (!name) return "Usuario";
    return name.toLowerCase().split(" ")
      .map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
  };

  const primerNombre = formatName(nombre).split(" ")[0];

  const fechaFormateada = hora.toLocaleDateString("es-CO", {
    weekday: "long", year: "numeric", month: "long", day: "numeric"
  });

  const horaFormateada = hora.toLocaleTimeString("es-CO", {
    hour: "2-digit", minute: "2-digit", second: "2-digit"
  });

  // Tarjetas de acceso rápido
  const tarjetas = [
    { icon: "fas fa-comments", label: "Historial Chats", color: "#4361ee", bg: "#eef0fd", ruta: "/historial_chats" },
    { icon: "fas fa-file-invoice-dollar", label: "Facturación", color: "#2ec4b6", bg: "#e8faf9", ruta: "/facturacion" },
    { icon: "fas fa-user-plus", label: "Prospectos", color: "#cb6ea9", bg: "#fbe6f3", ruta: "/prospectos" },

    ...(perfil === "Administrador"
      ? [
        { icon: "fas fa-user", label: "Suscriptores", color: "#159272", bg: "#e6f7f3", ruta: "/suscriptores" },
        { icon: "fas fa-user-cog", label: "Gestión Usuarios", color: "#7b2d8b", bg: "#f5e9f7", ruta: "/gestion_usuarios" },
        { icon: "fas fa-phone-square", label: "Teléfonos Notificación", color: "#f77f00", bg: "#fff4e6", ruta: "/telefonos_notificacion" },
      ]
      : []
    ),
  ];

  return (
    <div className="inicio-wrapper">

      {/* ── Hero ─────────────────────────────────────── */}
      <div className="inicio-hero">
        <div className="inicio-hero-content">
          <div className="inicio-hero-left">
            <p className="inicio-saludo">{getSaludo()}, <strong>{primerNombre}!</strong> 👋</p>
            <h1 className="inicio-titulo">Bienvenido a <span>CRM PowerSoft</span></h1>
            <p className="inicio-subtitulo">Tecnología inteligente para gestionar tus clientes.</p>
            <div className="inicio-badge-perfil">
              <i className="fas fa-shield-alt mr-1"></i> {perfil || "Usuario"}
            </div>
          </div>
          <div className="inicio-hero-right">
            <div className="inicio-geo">
              <div className="geo-ring geo-ring-1"></div>
              <div className="geo-ring geo-ring-2"></div>
              <div className="geo-ring geo-ring-3"></div>
              <div className="geo-dot geo-dot-1"></div>
              <div className="geo-dot geo-dot-2"></div>
              <div className="geo-dot geo-dot-3"></div>
              <div className="geo-dot geo-dot-4"></div>
              <div className="geo-line geo-line-1"></div>
              <div className="geo-line geo-line-2"></div>
              <div className="geo-center">
                <i className="fas fa-star"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Fecha y hora ─────────────────────────────── */}
      <div className="inicio-datetime-bar">
        <span><i className="fas fa-calendar-alt mr-2"></i>{fechaFormateada}</span>
        <span className="inicio-clock"><i className="fas fa-clock mr-2"></i>{horaFormateada}</span>
      </div>

      {/* ── Acceso rápido ─────────────────────────────── */}
      <div className="inicio-section">
        <h4 className="inicio-section-title">
          <i className="fas fa-th-large mr-2"></i>Acceso rápido
        </h4>
        <div className="inicio-cards-grid">
          {tarjetas.map((t, i) => (
            <a href={t.ruta} key={i} className="inicio-card" style={{ "--card-color": t.color, "--card-bg": t.bg }}>
              <div className="inicio-card-icon">
                <i className={t.icon}></i>
              </div>
              <span className="inicio-card-label">{t.label}</span>
              <i className="fas fa-arrow-right inicio-card-arrow"></i>
            </a>
          ))}
        </div>
      </div>

      {/* ── Footer ───────────────────────────────────── */}

    </div>
  );
}

export default Inicio;